import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import Form from '../settings/Form'
import { present, email, number, phone } from '../settings/Form/validators'

@inject('websites', 'auth', 'users', 'leads')
@observer
export default class WebsiteLeadInvite extends Component {
  website = this.props.websites.current

  handleData = data => {
    return this.props.leads.create(data).then(newLead => {
      const { location: { state={} }, router } = this.props
      if (state.return_to) {
        router.replace({
          ...state.return_to,
          query: { ...state.return_to.query, lead_id: newLead.id }
        })
      } else {
        this.props.router.push({
          pathname: `/website/${this.website.id}/leads`,
          state: { highlight: newLead.id }
        })
      }
    })
  }

  getAssignedTo() {
    const { auth: { user }, users } = this.props
    if (user.admin) {
      return (
        <div className="form-section">
          <label>Assigned To:</label>
          <select name="assigned_to_id" defaultValue={user.id}>
            {users.map(({ name, id }) => (
              <option value={id} key={id}>{name}</option>
            ))}
          </select>
        </div>
      )
    } else {
      return (
        <div className="form-section">
          <label>Assigned To: Me</label>
          <input type="hidden" name="assigned_to_id" value={user.id} />
        </div>
      )
    }
  }

  render() {
    const validations = [
      { field: 'first_name', validate: present, message: 'Please enter a first name' },
      { field: 'last_name', validate: present, message: 'Please enter a last name' },
      { field: 'email', validate: [present, email], message: 'Please enter a valid email' },
      { field: 'phone', validate: phone, message: 'Phone number is not valid' },
      { field: 'assigned_to_id', validate: [present, number], message: 'Please assign to a user' }
    ]
    return (
      <div className="container centered padded invite-lead">
        <Form className="full" onData={this.handleData} validations={validations}>
          <div className="panel padded">
            <h2 className="title">Create a Lead</h2>

            <div className="form-section">
              <label htmlFor="first_name">First Name</label>
              <input name="first_name" id="first_name" placeholder="Enter First Name" />
            </div>

            <div className="form-section">
              <label htmlFor="last_name">Last Name</label>
              <input name="last_name" id="last_name" placeholder="Enter Last Name" />
            </div>

            <div className="form-section">
              <label htmlFor="email">Email</label>
              <input name="email" id="email" placeholder="Enter Email" />
            </div>

            <div className="form-section">
              <label htmlFor="phone">Phone</label>
              <input name="phone" id="phone" placeholder="Phone (Optional)" />
            </div>

            <input type="hidden" id="admin_invitation_status" name="admin_invitation_status" value="accepted" />

            {this.getAssignedTo()}

          </div>

          <button type="submit" className="big shadowed">Create Lead</button>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Leads/Invite.js